import { PROJECTS } from "@/data/projects";
import { ProjectCard, spanFor } from "@/components/ProjectCard";
import { SectionLabel } from "@/components/SectionLabel";
import { CtaLink } from "@/components/CtaLink";

const FEATURED = ["modern-brand-identity", "luxury-packaging-concept", "mobile-application-interface", "creative-marketing-campaign"];

export const SelectedWork = () => {
  const items = FEATURED.map((slug) => PROJECTS.find((p) => p.slug === slug)).filter(Boolean);
  return (
    <section className="bg-mist/60 py-24 sm:py-36" aria-labelledby="work-heading" data-testid="home-selected-work">
      <div className="shell">
        <div className="mb-14 flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <div>
            <SectionLabel index="03">Selected work</SectionLabel>
            <h2 id="work-heading" className="mt-6 max-w-3xl font-display text-4xl font-extrabold tracking-[-0.04em] text-navy sm:text-5xl lg:text-6xl">
              Concepts that show <span className="text-royal">how we think.</span>
            </h2>
            <p className="mt-5 max-w-xl text-base text-slatey">All projects shown are clearly labelled concept or speculative designs created to demonstrate our approach — not client work.</p>
          </div>
          <CtaLink to="/portfolio" variant="navy" testid="home-view-portfolio-button">View portfolio</CtaLink>
        </div>
        <div className="grid gap-x-6 gap-y-14 md:grid-cols-12">
          {items.map((p, i) => (
            <div key={p.slug} className={spanFor(i)}>
              <ProjectCard project={p} index={i} wide={spanFor(i).includes("7")} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
